import { useEffect, useState } from 'react';

import Image from 'react-bootstrap/Image';

import Menu from '../../components/MenuBEA';

import header from '../../images/bea-header.png'

import constantes from '../../helpers/constanteHelper';

function SobreBEA() {
    const [width, setWidth] = useState(window.innerWidth);

    function observarMudancaWidth() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.addEventListener('resize', observarMudancaWidth);

        // Scroll para o topo da página para melhor visualização no mobile ou em resoluções menores
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })

        return () => {
            window.removeEventListener('resize', observarMudancaWidth);
        }
    }, []);

    const resolucaoMobile = width <= constantes.RESPONSIVIDADE.LARGURA_MOBILE;

    return (
        <>
            <div style={{ minHeight: '100vh', background: constantes.CORES.LARANJA_BEA }} className='text-center d-flex flex-column align-items-center'>
                <Menu opcaoSelecionada={'sobre'} />
                <div className='animate__animated animate__fadeIn d-flex flex-column align-items-center'>
                    <div style={{ height: resolucaoMobile ? '20px' : '80px' }}></div>

                    <Image style={{ height: '500px', objectFit: 'contain', padding: '20px' }} src={header} alt='logo' fluid />
                    <h1 className={resolucaoMobile ? 'mb-5' : 'mt-5 mb-5'} style={{ color: constantes.CORES.BRANCO_PADRAO, fontWeight: 700 }}>Certificação BEA</h1>

                    <span className='mb-5' style={{ width: resolucaoMobile ? '90vw' : '70vw', color: constantes.CORES.BRANCO_PADRAO, fontSize: '20px', whiteSpace: 'pre-line', textAlign: resolucaoMobile ? 'justify' : 'center' }}>
                        Nosso Programa de Certificação em Bem-Estar Animal foi criado com o objetivo de assegurar que os produtos de origem animal que estampam este selo em suas embalagens são provenientes de fazendas, granjas e criatórios que prezam pelo bem-estar animal.<br/><br/>
                        O programa de certificações, desenhado por nós, é uma certificação privada de terceira parte, e foi baseado nas regras da Organização Mundial de Saúde, bem como nas pesquisas desenvolvidas por Universidades e Instituições brasileiras e internacionais, adaptadas para a realidade da pecuária.<br/><br/>
                    </span>

                </div>
            </div>
        </>
    );
}

export default SobreBEA;
